import React, { useEffect, useRef, useState } from "react";

import { motion, animate } from "motion/react";

import { useNavigate } from "react-router";

import "../styles.css"; // Custom styles for the app
import { AirbudsYearlyHeader } from "../component/storyHeader";
import { TopArtistCard } from "../component/topArtistCard";
import WordByWordAnimation from "../component/wordByWord";
import { Counter } from "../component/counter";
import { CompatAvatarAnimation } from "./compatAvatarAnimation";
import EmojiWave, { defaultEmojis } from "./emojiWave";
import { CompatReactionSentAnimation } from "./compatReactionSent";
import { CompatResult } from "./compatResult";
import { useData } from "../data/dataContext";
import { ComebackMessage } from "../comebackToUnlock";
import StoryProgressBar from "../component/pagination";
import { EmptyScreen } from "../validation/validation";
import { useMusicPlayer } from "../music/musicPlayerContext";
import { useStateAndRef } from "../intro";

export const DoorAnimation = ({ top }) => {
  const [showCounter, setShowCounter] = useState(false);
  useEffect(() => {
    //Implementing the setInterval method
    const interval = setTimeout(() => {
      setShowCounter(true);
    }, 1000);

    //Clearing the interval
    return () => clearTimeout(interval);
  }, [showCounter]);

  return (
    <motion.div
      className="doorAnimation"
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 0.8,
        delay: 0.0,
        ease: [0, 0.71, 0.2, 1.01],
      }}
    >
      <img
        src={require("../assets/img/door.svg")}
        alt="airbuds yearly recap"
        className="door"
      />

      {showCounter && <Counter from={0} to={top} />}
    </motion.div>
  );
};

export const Compatibility = () => {
  const { data } = useData();
  const [stepp, setStepe] = useState(0);
  const navigate = useNavigate();
  const { setMusicURL } = useMusicPlayer();
  const [showMusic, setShowMusic] = useState(false);
  const [currentSongIndex, setCurrentSongIndex, refCurrentSong] =
    useStateAndRef(0);

  useEffect(() => {
    if (
      data &&
      data.compatible_friends &&
      data.compatible_friends.length > 0 &&
      data.compatible_friends[0].song_ids &&
      data.compatible_friends[0].song_ids[0].preview
    ) {
      setShowMusic(true);
      setMusicURL(data.compatible_friends[0].song_ids[0].preview);
    }

    return () => {
      setMusicURL(null);
    };
  }, [data]);



  if (!data) {
    return (
      <EmptyScreen text="loading..." closeAction={() => navigate("/menu")} />
    );
  }

  if (!data.compatible_friends && !data.compatible_friends.length <= 0) {
    return (
      <EmptyScreen text="no compat" closeAction={() => navigate("/menu")} />
    );
  }

  const rank = data.compatible_friends[0].rank;
  const score = data.compatible_friends[0].score;
  const song_count = data.compatible_friends[0].song_count;
  const reactions_count = data.compatible_friends[0].reactions_count;
  const songs = data.compatible_friends[0].song_ids;
  const user = data.compatible_friends[0].user_id;
  const me = data.user;

  const emojis = data.compatible_friends[0].top_reactions
    ? data.compatible_friends[0].top_reactions
        .filter((reaction) => reaction.kind === "emoji") // Filter only emojis
        .map((reaction) => reaction.body) // Extract the "body" field
    : defaultEmojis;

  const STEP_COUNT = 7;

  const previous = () => {
    setStepe(Math.max(stepp - 1, 0));
  };

  const next = () => {
    if (stepp == STEP_COUNT) {
      navigate("/menu");
    } else {
      setStepe(Math.min(stepp + 1, STEP_COUNT));
    }
  };

  const renderState = (state) => {
    switch (state) {
      case 0:
        return (
          <WordByWordAnimation text="Let's maybe spare your dating life this year and focus on friends, shall we?" />
        );
      case 1:
        return <WordByWordAnimation text="Among all your friends on Airbuds" />;
      case 2:
        return (
          <WordByWordAnimation text="There is one that matches your freak (musically)" />
        );
      case 3:
        return (
          <CompatAvatarAnimation
            me={me}
            user={user}
            score={Math.round(score)}
          />
        );
      case 4:
        return <EmojiWave emojis={emojis} next={() => setStepe(5)} />;
      case 5:
        return (
          <CompatReactionSentAnimation
            emojis={emojis.concat(emojis)}
            me={me}
            user={user}
            count={reactions_count}
          />
        );
      case 6:
        return (
          <CompatResult
            me={me}
            user={user}
            songs={songs}
            songCount={song_count}
            next={() => setStepe(7)}
          />
        );
      default:
        return (
          <ComebackMessage
            featureText="Come back tomorrow to unlock your next stat: Get validated for your Top Genre"
            next={() => {}}
          />
        );
    }
  };

  return (
    <div className="app-compat-container ">
      <div className="compat-gradient-background"></div>
      <div className="app-compat-content">{renderState(stepp)}</div>
      <StoryOverlay
        className={stepp == 6 ? "not-clickable" : ""}
        prev={previous}
        next={next}
      />
      <AirbudsYearlyHeader
        closeAction={() => {
          navigate("/menu");
        }}
        showMusic={showMusic}
      />
      <StoryProgressBar
        className="story-bar"
        totalPages={STEP_COUNT}
        currentPage={stepp}
        duration={0}
      />
    </div>
  );
};

export const StoryOverlay = ({ className, prev, next }) => {
  return (
    <div className={"story-overlay " + className}>
      <button className="prev" onClick={prev}>
        {" "}
      </button>
      <button className="next" onClick={next}>
        {" "}
      </button>
    </div>
  );
};
